
import React, { useEffect, useState } from "react";
import ToastNotification from '../../../components/ToastNotification';
import { FaRegEye } from "react-icons/fa";
import { MdOutlineVerifiedUser } from "react-icons/md";
import Select, { components } from 'react-select';
import { CiViewList } from "react-icons/ci";
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import { CiEdit } from "react-icons/ci";
import axios from "axios";

function CostCenter({ adminData, branchID }) {

  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });

  const showToast = (message, bg = 'success') => {
    setToast({ show: true, message, bg });
  };


  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [user, setUser] = useState([]);
  const [linkedToOptions, setLinkedToOptions] = useState([]);
  const [linkedTo, setLinkedTo] = useState(null);
  const [linkType, setLinkType] = useState(null);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [options, setOptions] = useState([]);
  const [fetchCost, setFetchCost] = useState([]);

  // const options = user.map(t => ({
  //   value: t.id,
  //   label: `${t.first} ${t.middle}  ${t.last} - ${t.emp_id}`
  // }));


  const handleAddClick = () => {
    setShowForm(true);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedEmployee || !linkType || !linkedTo) {
      showToast("Please fill all required fields", 'warning');
      return;
    }

    const payload = {
      employee_id: selectedEmployee.value,
      link_type: linkType.value,
      linked_to_id: linkedTo.value
    };

    try {
      if (editId) {

        await axios.put(

          `https://api.skyguard.group/api/update-link/${editId}`,
          {
            ...payload,
            edited_by: adminData.user.id
          }

        );
        showToast("Cost center updated successfully", 'success');
      } else {

        const result = await axios.post(
          "https://api.skyguard.group/api/add-cost-center",
          {
            ...payload,
            added_by: adminData.user.id
          }

        );
        showToast("Cost center added successfully", 'success');
      }

      // reset form
      setSelectedEmployee(null);
      setLinkType(null);
      setLinkedTo(null);
      setEditId(null);
      setShowForm(false);
      fectCostCenter();

    } catch (error) {
      console.error(error);
      showToast("Something went wrong", 'danger');
    }
  };




  const fectEmphDetail = async () => {
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
      setUser(resEmployee.data.result);

      const opts = resEmployee.data.result.map((t) => ({
        value: t.id,
        label: `${t.first} ${t.middle || ""} ${t.last} - ${t.emp_id}`,
      }));

      setOptions(opts);

      const options = resEmployee.data.result.map(emp => ({
        value: emp.id,
        label: `${emp.first} ${emp.middle}  ${emp.last} - ${emp.emp_id}`
      }));

      setLinkedToOptions(options);
    } catch (error) {
      console.log(error)
    }
  };

  const fectCostCenter = async () => {
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-cost-center');
      console.log(res.data)
      setFetchCost(res.data);
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
    if (user && user.length) {
      const opts = user.map((t) => ({
        value: t.id,
        label: `${t.first} ${t.middle || ""} ${t.last} - ${t.emp_id}`,
      }));
      setOptions(opts);
    }
  }, [user]);

  useEffect(() => {

    fectEmphDetail();
    fectCostCenter();
  }, [])


  const handleEdit = (form) => {

    setEditId(form.id);
    setIsEditMode(true);
    setShowForm(true);

    setSelectedEmployee({
      value: form.employee_id,
      label: getFullName(
        form.employee_first,
        form.employee_middle,
        form.employee_last
      )
    });


    setLinkType({
      value: form.link_type,
      label: "Employee"
    });


    setLinkedTo({
      value: form.linked_to_id,
      label: getFullName(
        form.linked_first,
        form.linked_middle,
        form.linked_last
      )
    });
  };


  const filteredData = fetchCost.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };


  const getFullName = (first, middle, last) => {
    return [first, middle, last].filter(Boolean).join(" ");
  };


  return (
    <>

      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <h3 className='my-3 fw-bold fs-5 golos'>Cost Center</h3>

          <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">


            <div className="mb-2 w-50 w-md-50 pe-md-2">
              <input
                className="form-control w-100"
                list="datalistOptions"
                placeholder="Search by Role,Department...."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>


            <div className="mb-2">
              <button className="btn btn-success" onClick={handleAddClick}>
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>

          </div>


          {showForm && (
            <div className="row justify-content-center">
              <div className="col-12 col-sm-10 col-md-6 col-lg-5">
                <div className="card shadow-sm p-4 border-0">

                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">



                        <div className="col-12 mb-3">
                          <label className="form-label fw-medium">Select Employee</label>
                          <Select
                            options={options}
                            value={selectedEmployee}
                            onChange={setSelectedEmployee}
                            placeholder="Select Employee"
                            isClearable
                          />
                        </div>

                        <div className="col-12 col-md-6 mb-2">
                          <label className="form-label fw-medium">Link Type</label>
                          <Select
                            placeholder="Select Link Type"
                            isClearable
                            value={linkType}
                            onChange={setLinkType}
                            options={[
                              { value: "employee", label: "Employee" }
                            ]}
                          />
                        </div>

                        <div className="col-12 col-md-6 mb-2">
                          <label className="form-label fw-medium">Linked To</label>
                          <Select
                            placeholder="Select Employee"
                            isClearable
                            options={linkedToOptions}
                            value={linkedTo}
                            onChange={setLinkedTo}
                          />
                        </div>


                      </div>

                      <div className="d-flex justify-content-center gap-2 mt-3">
                        <button className="btn btn-success px-4" onClick={handleSubmit}>
                          {editId ? "Update" : "Save"}
                        </button>

                        <button
                          type="button"
                          className="btn btn-secondary px-4"
                          onClick={() => {
                            setShowForm(false);
                            setIsEditMode(false);

                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          )}



          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>

              <thead className='table-info'>
                <tr>
              <th scope='col'>Action</th>
                  <th scope='col'>Cost Center</th>
                  <th scope='col'>Employee Name</th>



                  <th scope='col'>Added By</th>
                  <th scope='col'>Added Date</th>
                  <th scope='col'>Edit By</th>
                  <th scope='col'>Edit Date</th>
                
                </tr>
              </thead>
              <tbody>
                {filteredData.map((acc, idx) => (
                  <tr key={idx}>

                        <td>
                      <button className="btn btn-success" onClick={() => handleEdit(acc)}>
                        <CiEdit size={20} />
                      </button>
                    </td>

                    <td>
                      {getFullName(
                        acc.employee_first,
                        acc.employee_middle,
                        acc.employee_last
                      )}
                    </td>

                    <td>
                      {getFullName(
                        acc.linked_first,
                        acc.linked_middle,
                        acc.linked_last
                      )}
                    </td>
                    <td>{acc.added_by_first} {acc.added_by_middle}  {acc.added_by_last}   </td>

                    <td> {formatDateTime(acc.created_at)}  </td>
                   <td>  {acc.edited_by_first
                      ? getFullName(
                        acc.edited_by_first,
                        acc.edited_by_middle,
                        acc.edited_by_last
                      )
                      : "-"}</td>

                   
                    <td>{formatDateTime(acc.updated_at)}  </td>
                  
                  </tr>
                ))}
              </tbody>
            </table>
          </div>


        </div>
      </div>
    </>
  )
}

export default CostCenter